import type { IconProps } from "./types";

export function Tool({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
        ? color
        : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.0029 2.70118C15.2562 2.47284 16.5494 2.63211 17.71 3.15723C17.9791 3.27904 18.1716 3.52575 18.2246 3.81641C18.2774 4.10684 18.1842 4.40448 17.9756 4.61329L14.6133 7.97559L16.0234 9.38575L19.3867 6.02442L19.4688 5.95118C19.6696 5.79438 19.9295 5.72922 20.1836 5.7754C20.4743 5.82836 20.721 6.02088 20.8428 6.29005C21.3679 7.45062 21.5272 8.74386 21.2988 9.99708C21.0705 11.2503 20.4652 12.4039 19.5645 13.3047C18.6636 14.2055 17.5092 14.8107 16.2559 15.0391C15.2118 15.2292 14.1403 15.1497 13.1406 14.8145L7.37598 20.5811C6.85135 21.1057 6.13938 21.4004 5.39746 21.4004C4.65553 21.4004 3.94357 21.1057 3.41895 20.5811C2.89432 20.0564 2.59963 19.3445 2.59961 18.6025C2.59961 17.8606 2.89435 17.1487 3.41895 16.624L9.18457 10.8584C8.84963 9.85902 8.77086 8.78784 8.96094 7.74415C9.18929 6.49084 9.7945 5.33637 10.6953 4.43555C11.5961 3.53485 12.7497 2.92954 14.0029 2.70118ZM4.40039 18.6025C4.40041 18.8671 4.50533 19.1206 4.69238 19.3076C4.87944 19.4947 5.13292 19.5996 5.39746 19.5996C5.66199 19.5996 5.91547 19.4947 6.10254 19.3076L12.2842 13.127L12.3896 13.0361C12.6485 12.8471 12.9926 12.8084 13.291 12.9434C14.1182 13.3177 15.0403 13.4313 15.9336 13.2686C16.8269 13.1058 17.6499 12.6743 18.292 12.0322C18.934 11.3902 19.3646 10.5671 19.5273 9.67384C19.6053 9.24603 19.6174 8.8121 19.5703 8.38477L17.2871 10.6699L17.2803 10.6758C16.9449 11.0045 16.4941 11.1884 16.0244 11.1885C15.5548 11.1885 15.104 11.0045 14.7686 10.6758L14.7617 10.6699L13.3242 9.23243V9.23145C13.0365 8.93785 12.859 8.55607 12.8193 8.1504L12.8115 7.97559L12.8193 7.80079C12.8591 7.39517 13.0365 7.01327 13.3242 6.71973L13.3301 6.7129L13.3398 6.70411L15.6143 4.42872C15.1873 4.38179 14.7536 4.39482 14.3262 4.47266C13.4329 4.63542 12.6098 5.06602 11.9678 5.70802C11.3257 6.3501 10.8942 7.17308 10.7314 8.06641C10.5687 8.9597 10.6823 9.88176 11.0566 10.709C11.2109 11.0502 11.1378 11.451 10.873 11.7158L4.69238 17.8975C4.50535 18.0845 4.40039 18.338 4.40039 18.6025Z"
        fill={currentColor}
      />
    </svg>
  );
}
